export default __webpack_public_path__ + "static/media/soul-grey.5617f885.png";